import React from 'react';
import { useNavigate } from 'react-router-dom';
import SupplierForm from '../../components/Suppliers/SupplierForm';
import Toast from '../../components/Common/Toast';
import { useState } from 'react';

const CreateSupplier = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Proveedor creado exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/suppliers');
    }, 1500);
  };

  const handleError = (error) => {
    setToast({
      isOpen: true,
      message: error.response?.data?.message || 'Error al crear el proveedor',
      type: 'error'
    });
  };

  return (
    <div>
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-800">Nuevo Proveedor</h1>
            <p className="text-gray-600 mt-1">Complete el formulario para crear un nuevo proveedor</p>
          </div>

          {/* Formulario */}
          <SupplierForm
            isPageMode={true}
            showEntityTypes={false}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        </div>
      </div>

      {/* Toast de notificaciones */}
      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, isOpen: false })}
      />
    </div>
  );
};

export default CreateSupplier;
